module.exports = __webpack_public_path__ + "static/description-44ccab2fd1b4ffbcffe5d75d23a96067.png";